import { Locale, LANGUAGE_CONFIG } from "../locales/constants";

export function formatCurrency(value: number, locale: Locale): string {
	const config = LANGUAGE_CONFIG[locale];

	try {
		return new Intl.NumberFormat(locale, {
			style: "currency",
			currency: config.currency,
		}).format(value);
	} catch {
		return `${value} ${config.currency}`;
	}
}

export function formatDate(value: Date | string, locale: Locale): string {
	const date = typeof value === "string" ? new Date(value) : value;

	try {
		return new Intl.DateTimeFormat(locale).format(date);
	} catch {
		return date.toLocaleDateString();
	}
}

export function formatNumber(value: number, locale: Locale): string {
	try {
		return new Intl.NumberFormat(locale).format(value);
	} catch {
		return value.toString();
	}
}
